import Image from 'next/legacy/image'

import React from 'react'

import generic from '@/assets/file-icons/generic-svgrepo-com.svg'
import { formatToFile } from '@/utils/formatToFile'

export const FileTypeIcon = (props: { type: string }) => {
  return (
    <div className='w-[28px] shrink-0'>
      <Image
        src={formatToFile.get(props.type) || generic}
        alt={'JPG file'}
        height={200}
        width={200}
        objectFit='contain'
        layout='responsive'
      />
    </div>
  )
}
